import axios from "../../axios/AxiosInstance";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/reusableComponents/Button";
import { Input } from "../../components/reusableComponents/Input";
import { Card } from "../../components/reusableComponents/Card";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [askedPassword, setAskedPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const askPassword = () => {
    if (!username) {
      toast.error("Veuillez entrer votre login");
      return;
    }

    setLoading(true);

    axios
      .post("/auth/ask-reset-password-freelance", { username })
      .then((res) => {
        setAskedPassword(true);
        setUsername("");
        toast.success("Un email de réinitialisation vous a été envoyé");
      })
      .catch((e) => {
        toast.error("Le login n'existe pas !");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      {!askedPassword && (
        <div className="w-full max-w-md rounded-2xl overflow-hidden shadow-lg bg-white p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-semibold text-gray-800 mb-2">
              J'M <span className="text-black">INTERIM</span>
            </h1>
          </div>

          <div className="mb-6">
            <h2 className="text-2xl font-medium text-gray-700 mb-2">
              Réinitialiser le mot de passe
            </h2>
            <p className="text-gray-500">
              Entrez votre login pour recevoir un lien de réinitialisation
            </p>
          </div>

          <div className="mb-6">
            <div className="relative">
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Votre login"
                className="h-12 pl-10 border-gray-200 rounded-xl bg-white focus:border-slate-400 focus:ring focus:ring-slate-300 focus:ring-opacity-50"
              />
              <div className="absolute left-3 top-3.5 text-gray-400">
                <Mail size={18} />
              </div>
            </div>
          </div>

          <Button
            onClick={askPassword}
            disabled={loading}
            className="w-full h-12 bg-black hover:bg-gray-900 text-white rounded-xl transition-colors duration-300"
          >
            Réinitialiser le mot de passe
          </Button>

          <div className="mt-4 text-center">
            <a
              href="/login"
              className="text-sm text-gray-500 hover:text-slate-700"
            >
              Retour à la connexion
            </a>
          </div>

          <div className="absolute -bottom-10 -right-10 w-24 h-24 border-[12px] border-gray-100 rounded-full opacity-50 hidden md:block"></div>
          <div className="absolute -top-10 -left-10 w-24 h-24 border-[12px] border-gray-100 rounded-full opacity-50 hidden md:block"></div>
        </div>
      )}

      {askedPassword && (
        <div className="flex w-1/2 flex-col h-1/2 items-center justify-center border border-black space-y-6 rounded-md p-4">
          <p className="text-black font-semibold text-xl text-center">
            Vous allez recevoir un mail avec un lien pour réinitialiser votre
            mot de passe
          </p>
          <button
            onClick={() => navigate("/login")}
            className="text-black text-sm border border-black rounded px-4 py-2 hover:bg-gray-100 transition"
          >
            Retour à la connexion
          </button>
        </div>
      )}
    </div>
  );
}
